import DocumentPage from "../../../../invoice/DocumentPage";
import { verifactuCorrectiveInvoiceConfig } from "./config";

const VerifactuCorrectiveInvoice = () => (
  <DocumentPage config={verifactuCorrectiveInvoiceConfig} />
);

export default VerifactuCorrectiveInvoice;